import { createContext } from 'react';

const AccordionContext = createContext({
  open: false,
  setOpen: () => {},
});

export default AccordionContext;
